import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ScheduleItem} from "../ScheduleItem";
import {BasicEventPlayer} from "../../../entities/auth/BasicEventPlayer";

@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.css']
})
export class ScheduleListComponent implements OnInit{
  @Input({required: true})
  items: ScheduleItem[]

  @Output()
  selectedItem: EventEmitter<ScheduleItem>;

  @Output()
  cancelledChanged = new EventEmitter<ScheduleItem>();

  columns: string[] = ['relative', 'name', 'starts', 'ends', 'delayed', 'cancelled'];

  constructor() {
    this.selectedItem = new EventEmitter<ScheduleItem>();
  }

  ngOnInit(): void {
  }

  select(item: ScheduleItem) {
    this.selectedItem.emit(item);
  }

  toggleCancelled(event: Event, item: ScheduleItem) {
    event.stopPropagation();
    item.cancelled = !item.cancelled;
    this.cancelledChanged.emit(item);
  }


}
